import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Slider from 'react-slick';
import { InnerPageSectionHeading } from './styles/SectionHeadline.styled';
import {
  TabWrapper,
  ButtonTab,
  TabDescription,
  DescriptionSection,
} from './styles/FacilitiesTabSection.styled';
import ThreeColumnsIntro from './ThreeColumnsIntro';
import { Container } from './styles/Container.styled';
import { LoadMoreButton, LoadMoreHdn } from './styles/LoadMoreButton.styled';
import ImageCarousel from './ImageCarousel';
import { NextArrow, PrevArrow } from './NextPrevArrow';

export default function Accommodations({ data, id, dir }) {
  const [toggleState, setToggleState] = useState(0);
  const handleNext = (curr, last) => setToggleState(+curr + 1 < +last ? +curr + 1 : +last);
  const handlePrev = (curr) => setToggleState(+curr - 1 > 0 ? +curr - 1 : 0);
  const settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3500,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          arrows: true,
          nextArrow: <NextArrow handleNext={handleNext} />,
          prevArrow: <PrevArrow handlePrev={handlePrev} />,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          autoplay: false,
          arrows: true,
          nextArrow: <NextArrow handleNext={handleNext} />,
          prevArrow: <PrevArrow handlePrev={handlePrev} />,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 1,
          autoplay: false,
          nextArrow: <NextArrow handleNext={handleNext} dir={dir} />,
          prevArrow: <PrevArrow handlePrev={handlePrev} dir={dir} />,
        },
      },
    ],
  };
  return (
    <InnerPageSectionHeading id={id} className="tabsection">
      <Container>
        <TabWrapper className="tab_pddn_wrapper accommodation_tab" dir={dir}>
          <Slider {...settings} dir="rtl">
            {data.accommodations.map((accommodation, index) => (
              <ButtonTab
                className={toggleState === index ? 'tabs active-tabs acc_tab' : 'tabs acc_tab'}
                onClick={() => setToggleState(index)}
                key={index}
              >
                {accommodation.content.logo != null ? (
                  <LazyLoadImage
                    width={135}
                    src={accommodation.content.logo.url}
                    effect="blur"
                    placeholderSrc={
                      accommodation.content.logo
                        ? `${accommodation.content.logo.url}?width=50&quality=50`
                        : null
                    }
                  />
                ) : null}
              </ButtonTab>
            ))}
          </Slider>
        </TabWrapper>
      </Container>

      <TabDescription className="tabgroup_descp tabgroup padnbtn_tabdesc" dir={dir}>
        {data.accommodations.map((accommodation, index) => (
          <DescriptionSection
            className={toggleState === index ? 'content active-content' : 'content'}
          >
            <Container className="padding-lr-zero">
              <ThreeColumnsIntro data={accommodation.content} dir={dir} />
            </Container>
            <ImageCarousel data={{ carouselImages: accommodation.content.images }} dir={dir} />
            <LoadMoreHdn className="image_carouselbutton">
              <LoadMoreButton dir={dir}>
                {accommodation.content.website ? (
                  <a
                    href={accommodation.content.website.url}
                    target={accommodation.content.website.target}
                    rel="noreferrer"
                    dir={dir}
                  >
                    {accommodation.content.website.name}
                  </a>
                ) : null}
              </LoadMoreButton>
            </LoadMoreHdn>
          </DescriptionSection>
        ))}
      </TabDescription>
    </InnerPageSectionHeading>
  );
}
